import { lazy, Suspense, ComponentProps } from 'react'
import Loader from 'components/SimpleLoader'

const Publishing = lazy(() =>
  import(
    /* webpackPrefetch: true */
    /* webpackChunkName: "post" */
    './Publishing'
  )
)

export default function AsyncPost(props: ComponentProps<any>) {
  return (
    <Suspense fallback={<Loader title="Loading Publishing…" />}>
      <Publishing {...props} />
    </Suspense>
  )
}
